import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'react-final-form';
import {Animate} from '@tenancy.nz/design-system';
import {isEmpty} from 'utils/helpers';

function Conditional({children, is, isNot, notIn, show, when, ...rest}) {
  return (
    <>
      {show && <Animate>{children}</Animate>}
      {!show && isEmpty(notIn) && (
        <Field name={when} subscription={{value: true}} {...rest}>
          {({input: {value}}) =>
            (isNot === null ? value === is : value !== isNot) && (
              <Animate>{children}</Animate>
            )
          }
        </Field>
      )}
      {!show && !isEmpty(notIn) && (
        <Field name={when} subscription={{value: true}} {...rest}>
          {({input: {value}}) =>
            !notIn.includes(value) && <Animate>{children}</Animate>
          }
        </Field>
      )}
    </>
  );
}

Conditional.propTypes = {
  children: PropTypes.node.isRequired,
  notIn: PropTypes.array,
  is: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  isNot: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),

  show: PropTypes.bool,
  when: PropTypes.string,
};

Conditional.defaultProps = {
  show: false,
  notIn: [],
  is: null,
  isNot: null,
  when: null,
};

export default Conditional;
